import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Heading1, Text, rem, greaterThan } from 'localmed-core';
import { display as StyledSystemDisplay } from 'styled-system';

import { ThemeProps } from '../../../types';

export const HeaderWrapper = styled('header')(
  ({ theme }: ThemeProps) => css`
    display: flex;
    justify-content: start;
    align-items: center;
    color: ${theme.colors.white};
  `
);

export const H1 = styled(Heading1)(
  ({ theme }: ThemeProps) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${rem(18)};
    color: ${theme.colors.white};
  `
);

export const Box = styled('div')(css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`);

export const Image = styled('img')(
  ({ theme }: ThemeProps) => css`
    height: 52px;
    margin-right: ${theme.space.md};
    border-radius: 50%;
  `,
  greaterThan(
    'lg',
    css`
      height: 60px;
    `
  )
);

export const Span = styled('span')(
  ({ theme }: any) => css`
    padding: 0 ${theme.space.sm};
  `,
  StyledSystemDisplay
);

export const StyledText = styled(Text)(
  ({ theme }: ThemeProps) => css`
    margin-bottom: 0 !important;
    margin-top: ${theme.space.xs};
  `
);
